<article class="support">
  <p class="support__question" [class.support__question--small-margin]="question?.subLabel">
    {{ question?.label }}
    <span *ngIf="question?.subLabel" class="support__question__sub-label line-break">{{ question.subLabel }}</span>
  </p>
  <ul class="support__list">
    <li class="support__list__item" *ngFor="let answer of answers; trackBy: trackByAnswer">
      <button
        class="support__list__item__button btn-form"
        [class.btn-form--clicked]="answer.selected"
        (click)="clickAnswer(answer.value)"
      >
        {{ answer.label }}
      </button>
    </li>
  </ul>
  <button class="support__validate-button btn" (click)="clickValidate()">Valider</button>
  <button
    *ngIf="displayReturn"
    class="support__return-button btn-clean"
    (click)="clickReturn(question.trackEventReturnLabel)"
  >
    Retour
  </button>
</article>
